import { Route, Routes } from 'react-router';
import cn from 'classnames';
import Home from '../components/Home';
import RouterWrapper from '../components/RouterWrapper';

import { store } from '../app/store';
import MasterLayout from '../layouts/MasterLayout';

import './App.scss';


function App() {
  return (
    <div className={cn('fr ems', { 'fwe-pt-6': false })}>
      <RouterWrapper routeType={store.getState().base.routeType} basename={store.getState().base.baseName}>
        <MasterLayout>
          <Routes>
            <Route path={`/`} element={<Home />} />
          </Routes>
        </MasterLayout>
      </RouterWrapper>
    </div>
  );
}

export default App;
